const HowToUse = (): JSX.Element => {
  return (
    <div className="card-container flex-[4]">
      <p className="mt-10">ScheduleHowToUse</p>
    </div>
  );
};

export default HowToUse;
